const InitState = {
  currentRoute: {},
  currentLocation: {},
  matchRoutes: [],
};
export default InitState;
